import React from 'react';
import { Box, Typography, Rating } from '@mui/material';

interface RatingDisplayProps {
  rating: number;
  reviewCount?: number;
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
}

const RatingDisplay: React.FC<RatingDisplayProps> = ({
  rating,
  reviewCount,
  size = 'medium',
  showLabel = true,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Rating
        value={rating}
        precision={0.1}
        readOnly
        size={size}
      />
      {showLabel && (
        <Typography variant="body2" color="text.secondary">
          {rating.toFixed(1)}
          {reviewCount !== undefined && ` (${reviewCount} отзывов)`}
        </Typography>
      )}
    </Box>
  );
};

export default RatingDisplay;


